import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import moment from 'moment';
import {useHistory} from 'react-router-dom';
import {Motion, spring} from 'react-motion';
import {connect} from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import SearchFieldComponent from '../components/common/SearchFieldComponent';
import CustomerNameTableCell from '../components/customer/CustomerNameTableCell';
import {ReactComponent as Drawer} from '../assets/drawer.svg';
import {
    groupAndSortItemsByFieldCharacter,
    groupAndSortItemsByFieldName,
    sortItemByField
} from '../utils/customersUtils';
import gkTableHeading from '../data/tableHeadings/gkContractsTableHeading.json';
import smsTableHeadings from '../data/tableHeadings/smsContractsTableHeading.json';

import Pagination from '../components/common/Pagination';
import TableHeadingComponent from '../components/common/TableHeadingComponent';
import SignatureActionButton from '../components/common/SignatureActionButton';
import ActionButton2 from '../components/common/Action Buttons/ActionButton2';
import LinkTableCellComponent from '../components/common/LinkTableCellComponent';
import ContractSignContainer from '../components/ContractSignContainer';
import {
    agreementSignedEvent,
    CONTRACTS,
    deliverySlipUploadedEvent,
    devicesDeliveredEvent,
    getAllContracts,
    paymentConfirmedEvent,
    paymentIssuedEvent,
    updateContract, updateContractSchedule
} from '../redux/actions/contractsActions';
import TableRowGroupsComponent from '../components/common/TableRowGroupsComponent';
import TableCell from '../components/table/TableCell';
import {roles} from '../utils/auth';
import ContractInfoSidePanel from '../components/contracts/ContractInfoSidePanel';
import IconActionButton from '../components/common/IconActionButton';
import ContractDeliveryDialog from '../components/contracts/ContractDeliveryDialog';
import {filterObjectsBy, getDurationInMonth} from '../utils';
import {
    CONTRACT_KEYS,
    CONTRACT_STATUS,
    statusObjects,
    COMMITMENT_LETTER_STATUS,
    PROMISSORY_NOTE_STATUS, contractColorsCodes
} from '../utils/contracts';
import {fetchRepresentatives} from '../redux/actions/RepresentativesActions';
import ContractStatus from '../components/common/ContractStatus';
import {currencyFormatter} from '../utils/formatter';
import {getDocumentData, uploadDocument} from '../api/network/documentService';
import {addCustomerDocument, updatePromissory, updateCommitment, getCustomerDocument, getBusinessCustomerCall} from '../api/network/businessCustomerService';
import {DOCUMENT_TYPE} from '../const/documents';
import {
    PageWrapper,
    TableWrapper,
    PageHeadingWrapper,
    PageContentWrapper,
    ColumnHeading,
    NoContentWrapper,
    PaginationWrapper
} from '../styles/PageStyles';
import {profileSections} from './CustomerProfile';
import {pathName} from '../const/paths';
import CompanyContractExpansionPanel from '../components/contracts/CompanyContractExpansionPanel';
import {getCatalogDeviceInfoByInvoiceId, getCatalogPricing, getInvoiceId} from '../api/network/deviceService';
import {addNotification} from '../redux/actions/NotificationActions';
import DocumentSignContainer from '../components/DocumentSignContainer';
import {getOrder} from '../api/network/orderService';
import endpoints from '../endpoints';

const Label = styled.div`
    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */
    
    /* default/gray/500 */
    margin: 0 8px;
    color: #A0AEC0;
`;

const LoadingComponent = styled.div`
    z-index: 2;
    position: absolute;
    background-color: #A0AEC0;
    opacity: 0.5;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;



    .text{
        z-index: 3;
        font-family: Metropolis;
        font-size: 2rem;
        color: white;
        position: absolute;
        top: 50%;
        left:50%;
    }
    
`;

function FulfillmentContracts({
    auth,
    user,
    contracts,
    isFetchingContracts,
    getAllContracts,
    updateContract,
    fetchRepresentatives,
    addNotification,
    agreementSignedEvent,
    updateContractSchedule,
    ...props
}) {
    const history = useHistory();

    const tableHeadings = auth.role === roles.SMS ? smsTableHeadings : gkTableHeading;

    // contracts = contractTestData;
    useEffect(() => {
        getAllContracts();
        fetchRepresentatives();
    }, []);

    const [selectedContracts, setSelectedContracts] = useState([]);
    const [selectedContract, setSelectedContract] = useState(null);
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [process, setProcess] = useState('Processing Invoices...');

    // useEffect(() =>{
    //     if(selectedContract !== null){
    //         agreementSigned(selectedContract)
    //     }

    // },[selectedContract])

    // Document View States
    const [documentKey, setDocumentKey] = useState('');
    const [documentParams, setDocumentParams] = useState({});

    const [paginationPage, setPaginationPage] = useState(0);
    const [paginationRowsPerPage, setPaginationRowsPerPage] = useState(10);
    const [showSignContract, setShowSignContract] = useState(false);
    const [contractInfoPanel, setContractInfoPanel] = useState(false);
    const [contractDeliveryDialog, setContractDeliveryDialog] = useState(false);
    const [showDocumentPad, enableDocumentPad] = useState(false);
    const [invoiceDocument, setInvoiceDocument] = useState(null);
    const [expandedGroups, setExpandedGroups] = useState([]);

    const handleOnSearchChange = e => {
        setQuery(e.target.value);
    };

    const agreementSigned = contract => {
        const companyId = contract?.companyId;
        const customerId = contract?.customerId;
        const repId = contract?.representativeId;

        if (contract.commitmentLetter !== null && contract.promissoryNote !== null) {
            if (contract.commitmentLetter?.status === COMMITMENT_LETTER_STATUS.GK_SIGNED &&
                contract.promissoryNote?.status === PROMISSORY_NOTE_STATUS.GK_SIGNED) {
                updateContract(companyId, customerId, repId, contract.id, {status: CONTRACT_STATUS.AGREEMENT_SIGNED});
            } else {
                console.log(`Waiting for all Signatures${Object.entries(contract)}`);
            }
        }
    };

    const handleOnSelectAllClick = contracts => {
        if (!selectedContracts.length) {
            const customerSelections = [];
            contracts.forEach(item => {
                customerSelections.push(item.id);
            });

            setSelectedContracts([...customerSelections]);
        } else {
            setSelectedContracts([]);
        }
    };

    const handleOnCustomerNameClick = contract => {
        const {companyId, customerId} = contract;
        history.push(pathName.customersProfilePage(companyId, customerId), {section: profileSections.Identity});
    };

    const handleOnContractSelected = contract => {
        setSelectedContract(contract);
        setContractInfoPanel(true);
    };

    const handleOnPageChange = page => {
        setPaginationPage(page);
    };

    const handleOnRowsPerPageChange = rowsPerPage => {
        setPaginationRowsPerPage(rowsPerPage);
        setPaginationPage(0);
    };

    const handleOnSignAllBtnClick = e => {
        setShowSignContract(true);
    };

    const handleOnCheckboxSelected = (e, selectedItem) => {
        if (selectedContracts.includes(selectedItem.id)) {
            setSelectedContracts(selectedContracts.filter(c => c !== selectedItem.id));
        } else {
            setSelectedContracts([
                ...selectedContracts,
                selectedItem.id
            ]);
        }
    };

    const handleOnCheckboxGroupClick = (e, contracts, indeterminate) => {
        const {checked} = e.target;

        console.log('select all clicked', checked, contracts, indeterminate);
        let updatedSelections = [...selectedContracts];

        if (indeterminate || checked) {
            // add values
            contracts.forEach(item => {
                if (!selectedContracts.includes(item.id)) updatedSelections.push(item.id);
            });
        } else {
            // remove values
            updatedSelections = updatedSelections.filter(item => !contracts.find(contract => contract.id === item));
        }

        setSelectedContracts([...updatedSelections]);
    };

    const handleSignContractClick = () => {

    };

    const handleOnDialogSubmit = async (contract, deliverySlipDoc, invoiceNumber) => {
        setContractDeliveryDialog(false);
        setLoading(true);
        const contractForUpdate = {...contract};
        contractForUpdate.status = CONTRACT_STATUS.DELIVERY_SLIP_SENT;

        const {companyId, customerId, orderId, representativeId: repId, id: contractId, numInstallments} = contractForUpdate;

        // get invoice id from invoice number;
        try {
            const result = await getInvoiceId(invoiceNumber);
            contractForUpdate.invoiceId = result && result.invoice_id;
        } catch (e) {
            console.error(`something went wrong when getting invoice id for invoice number ${invoiceNumber}`, e);
        }

        // check if we have the invoice id, if not then stop the process
        if (!contractForUpdate.invoiceId) {
            addNotification('Failed to find invoice', 'error');
            setLoading(false);
            return;
        }

        // TODO: Loading needs to be shown for these calls right down to when the schedule variable is received; these are expensive service calls
        let items = [];
        // try {
        //     setProcess('Searching for Order...');
        //     const result = await getOrder(orderId);
        //     items = result.length ? result[0].items : items;
        // } catch (e) {
        //     console.error(`something went wrong when getting order id for order id number ${orderId}`, e);
        //     addNotification('Failed to find order id', 'error');
        //     setLoading(false);
        //     return;
        // }

        // if (items.length < 1) {
        //     console.error(`something went wrong when retrieving items for order id number ${orderId}`);
        //     addNotification('Failed to retrieve items', 'error');
        //     setLoading(false);
        //     return;
        // }

        let businessCustomer = null;
        try {
            const result = await getBusinessCustomerCall(contractForUpdate.companyId, contractForUpdate.customerId);
            businessCustomer = {...result};
        } catch (e) {
            console.error('something went wrong when getting customer information for ', e);
            addNotification('Failed to retrieve customer information', 'error');
            setLoading(false);
            return;
        }

        let itemsForSchedule = [];
        // try {
        //     setProcess('Looking up devices...');
        //     const itemIds = items.map(item => item.productId);
        //     const params = {
        //         term: numInstallments,
        //         ids: itemIds,
        //         tier: businessCustomer ? businessCustomer.priceTier || 0 : 0
        //     };
        //     const result = await getCatalogPricing(params);
        //     itemsForSchedule = result.devices ? result.devices : itemsForSchedule;
        // } catch (e) {
        //     addNotification('Failed to retrieve devices', 'error');
        //     setLoading(false);
        //     return;
        // }

        // if (itemsForSchedule.length < 1) {
        //     console.error(`something went wrong when retrieving devices for order id number ${orderId}`);
        //     addNotification('Failed to retrieve devices', 'error');
        //     setLoading(false);
        //     return;
        // }

        itemsForSchedule.map(item => {
            items.forEach(i => {
                if (item.id === i.productId) {
                    item.quantity = i.quantity;
                    item.slug = i.productId;
                }
            });
        });

        let deviceInfoForSchedule = [];
        // try {
        //     setProcess('Retrieving Device Info...');
        //     const result = await getCatalogDeviceInfoByInvoiceId(contractForUpdate.invoiceId);
        //     deviceInfoForSchedule = result;
        // } catch (e) {
        //     console.error(`something went wrong when retrieving device info for order id number ${orderId}`);
        //     addNotification('Failed to retrieve device info', 'error');
        //     setLoading(false);
        //     return;
        // }

        let devicesInfo = [];
        deviceInfoForSchedule.forEach(device => {
            devicesInfo = [...devicesInfo, ...device.devicesInfo];
        });

        /**
         * TODO:
         * @param 'schedule' needs to be appended to customer's contract and updated on the business customer object. Same exact procedure provided at ContractMiddleware:177.
         */
        const schedule = [];
        itemsForSchedule.forEach(item => {
            for (let i = 0; i < item.quantity; i++) {
                const deviceInfoIndex = devicesInfo.findIndex(el => el.slug === item.slug);
                const deviceInfo = deviceInfoIndex > -1 ? devicesInfo[deviceInfoIndex] : null;
                if (deviceInfoIndex > -1) devicesInfo.splice(deviceInfoIndex, 1);

                schedule.push({
                    financed_amount: `$${currencyFormatter(item.totalFinanced)}`,
                    terms: `${numInstallments} MONTHS`,
                    interest_rate: '10%',
                    description: `${item.name} ${item.size} ${item.color.color}`.toUpperCase(),
                    colour: item.color.color.toUpperCase(),
                    model_number: deviceInfo ? deviceInfo.model_number : '',
                    serial_number: deviceInfo ? deviceInfo.serial_number : '',
                    imei: deviceInfo ? deviceInfo.imei : '',
                });
            }
            setProcess('Done...');
        });
        // TODO: Loading ends here
        setLoading(false);
        // TODO: Remove after loading and updating of contract is properly done

        updateContractSchedule(contractForUpdate, schedule);

        if (deliverySlipDoc) {
            console.log('delivery slip upload', deliverySlipDoc);
            // uploading document to document service
            const formData = new FormData();
            formData.append('file', deliverySlipDoc);
            uploadDocument(formData)
                .then(result => {
                    addCustomerDocument(companyId, customerId, {
                        documentId: result.id,
                        documentTypeId: DOCUMENT_TYPE.Contracts
                    })
                        .then(result => {
                            contractForUpdate.deliverySlipDocumentId = result.id;
                            updateContract(companyId, customerId, repId, contractId, contractForUpdate, deliverySlipUploadedEvent(contractForUpdate));
                        })
                        .catch(error => console.log('error', error));
                })
                .catch(error => console.log('error', error));
        } else {
            updateContract(companyId, customerId, repId, contractId, contractForUpdate, deliverySlipUploadedEvent(contractForUpdate));
        }
    };

    const handleOnViewContractClick = () => {

    };

    const onExpanded = (value, expanded) => {
        console.log(value, expanded);

        // add when panel is expanded remove if it is being collapsed
        if (expanded) setExpandedGroups([...expandedGroups, value]);
        else setExpandedGroups(expandedGroups.filter(item => item !== value));
    };

    const showDeliveryDialog = contract => {
        setContractDeliveryDialog(true);
        setSelectedContract(contract);
    };

    function showContractDeliveryDialog(contract) {
        setContractDeliveryDialog(true);
        setSelectedContract(contract);
    }

    const handleOnDialogClose = () => {
        setContractDeliveryDialog(false);
        setSelectedContract({});
    };

    const handleGkCommitmentSignature = (documentId, contract) => {
        const {companyId} = contract;
        const {customerId} = contract;
        const repId = contract.representativeId;
        const promissorySigned = contract.promissoryNote?.status === PROMISSORY_NOTE_STATUS.GK_SIGNED;

        const params = {
            documentId,
            status: COMMITMENT_LETTER_STATUS.GK_SIGNED
        };

        // update commitment letter status
        updateCommitment(companyId, customerId, repId, contract.id, contract.commitmentLetter.id, params)
            .then(() => {
                const updatedContract = {
                    ...contract,
                    commitmentLetter: {...contract.commitmentLetter, ...params}
                };
                if (promissorySigned) updatedContract.status = CONTRACT_STATUS.AGREEMENT_SIGNED;

                agreementSignedEvent(updatedContract);
            });
        agreementSigned(contract);

        enableDocumentPad(false);
    };

    const handleGkPromissorySignature = (documentId, contract) => {
        const {companyId} = contract;
        const {customerId} = contract;
        const repId = contract.representativeId;
        const commitmentSigned = contract.commitmentLetter.status === COMMITMENT_LETTER_STATUS.GK_SIGNED;

        const params = {
            documentId,
            status: PROMISSORY_NOTE_STATUS.GK_SIGNED
        };
        // update commitment letter status
        updatePromissory(companyId, customerId, repId, contract.id, contract.promissoryNote.id, params)
            .then(() => {
                const updatedContract = {
                    ...contract,
                    promissoryNote: {...contract.promissoryNote, ...params}
                };
                // if commitment letter signed then update contract status
                if (commitmentSigned) updatedContract.status = CONTRACT_STATUS.AGREEMENT_SIGNED;

                agreementSignedEvent(updatedContract);
            });
        agreementSigned(contract);

        enableDocumentPad(false);
    };

    const handleSignCommitmentClick = async contract => {
        setDocumentKey(CONTRACT_KEYS.COMMITMENT_LETTER);
        let params = {};

        const commitmentLetterDocumentId = contract?.commitmentLetter?.documentId;
        try {
            const documentData = await getDocumentData(commitmentLetterDocumentId);
            params = documentData?.data?.metadata;
            setDocumentParams(params);

            console.log('Getting commitment letter data', params);
        } catch (e) {
            console.log('Failed to get document id for commitment letter', e);
        }

        enableDocumentPad(true);
        setSelectedContract(contract);
    };

    const handlePromissoryNoteClick = async contract => {
        setDocumentKey(CONTRACT_KEYS.PROMISSORY_NOTE);
        let params = {};

        // Get Document Params
        const promissoryNoteDocId = contract?.promissoryNote?.documentId;
        try {
            const documentData = await getDocumentData(promissoryNoteDocId);
            params = documentData?.data?.metadata;
            setDocumentParams({
                ...params,
                witness_name: `${user ? `${user.firstName || ''} ${user.lastName || ''}` : ''}`.trim(),
                witness_occupation: 'Loan Officer',
                witness_address: '73 Harbour Street, Kingston'
            });

            console.log('Getting promissory note data', params);
        } catch (e) {
            console.log('Failed to get document id for promissory note', e);
        }

        enableDocumentPad(true);
        setSelectedContract(contract);
    };

    const handleViewContract = documentId => {
        const url = endpoints.getDocument(documentId);
        window.open(url, '_blank');
    };

    const showSignAllBtn = (selectedContracts, userRole) => selectedContracts > 0 && userRole === roles.GK;

    const updateContractStatus = (contract, newStatus, actionEvent) => {
        const contractForUpdate = {...contract};
        const {companyId} = contractForUpdate;
        const {customerId} = contractForUpdate;
        const repId = contract.representativeId;

        contractForUpdate.status = newStatus;
        updateContract(companyId, customerId, repId, contractForUpdate.id, contractForUpdate);
    };

    /**
     *  Prepare the table cell data to be handed into the table Customers table.
     *
     *  The table cells are custom component. We create the table cell here
     *  so that we can handle any logic attached a table cell outside of the component
     */
    const addTableFields = (contractData, selectedContracts) => {
        if (contractData)
            return contractData.map(contract => {
                // console.log(`GK Contracts: ${Object.entries(contract.promissoryNote !== null ? contract.promissoryNote : 'null')}`);
                const selectedCustomerId = (selectedContracts) ? selectedContracts.id : false;

                // TODO change to use the customer id
                const mode = (selectedContracts.includes(contract.id)) ? 'selected' : (selectedCustomerId) ? 'disabled' : 'default';

                const deliveryActionButton = (role, status) => {
                    switch (role) {
                    case roles.SMS:
                        if (status === CONTRACT_STATUS.GK_SIGNED)
                            return <IconActionButton
                                key={9}
                                onClick={() => showDeliveryDialog(contract)}
                            >
                                Send Delivery Slip
                            </IconActionButton>;
                        if (status === CONTRACT_STATUS.DELIVERY_SLIP_SIGNED)
                            return <IconActionButton
                                key={9}
                                onClick={() => updateContractStatus(contract, CONTRACT_STATUS.DELIVERED, devicesDeliveredEvent(contract))}
                            >
                                Upload Signed Delivery Slip
                            </IconActionButton>;
                        if (status === CONTRACT_STATUS.DELIVERED || status === CONTRACT_STATUS.GK_PAID)
                            return <IconActionButton
                                key={9}
                                onClick={() => updateContractStatus(contract, CONTRACT_STATUS.PAYMENT_CONFIRMED, paymentConfirmedEvent(contract))}
                            >
                                Confirm Payment
                            </IconActionButton>;
                        break;
                    default:
                        return null;
                    }
                };

                const {status: currentStatus, commitmentLetter = {}, promissoryNote = {}} = contract;
                const userRole = auth.role;

                let status;
                const statusObject = statusObjects[currentStatus];

                if (!statusObject) {
                    status = {
                        message: currentStatus,
                        color: contractColorsCodes.Neutral
                    };// Fallback
                } else {
                    status = statusObject[auth.role] || statusObject;
                }

                if (currentStatus === CONTRACT_STATUS.GK_SIGNED) {
                    // Customer status messages based on if the customer signed
                    const documentsToSign = [];
                    if (commitmentLetter?.status === COMMITMENT_LETTER_STATUS.CUSTOMER_SIGNED) documentsToSign.push('Commitment Letter');
                    if (promissoryNote?.status === COMMITMENT_LETTER_STATUS.CUSTOMER_SIGNED) documentsToSign.push('Promissory Note');

                    status.message = `Awaiting ${documentsToSign.join(' & ')} signature(s)`;
                }

                return {
                    ...contract,
                    /**
                     *  NB - the table cell need to have a key because they are going to used in a list.
                     *  NB - the keys for `tableField` should map back to a key from the header data provided.
                     */
                    tableFields: {
                        id: contract.id,
                        name: <CustomerNameTableCell
                            key={1}
                            customerName={contract.companyName}
                            mode={mode}
                            onCustomerNameClick={() => handleOnCustomerNameClick(contract)}
                            loading={contract.syncing}
                            warning={contract.warning}
                        />,
                        monthlyPayment: <TableCell key={2}>${currencyFormatter(contract.monthlyPayment)}</TableCell>,
                        period: <TableCell
                            key={3}
                        >
                            {getDurationInMonth(contract.startDateOfContract, contract.endDateOFContract)}
                        </TableCell>,
                        totalCashPrice: <TableCell key={4}>${currencyFormatter(contract.totalCashPrice)}</TableCell>,
                        contractId: <LinkTableCellComponent
                            name={contract.contractNumber}
                            key={5}
                            onLinkClick={() => handleOnContractSelected(contract)}
                        />,
                        policies: <TableCell>{contract.policies}</TableCell>,
                        signatures: <TableCell key={7}>
                            {/* TODO: Conditional onClick action based on whether the GK Signature is entered or not */}
                            <SignatureActionButton
                                signatureImage={contract.gksignature}
                                onClick={() => {
                                    setSelectedContracts([contract.id]);
                                    setShowSignContract(true);
                                }}
                            />

                        </TableCell>,
                        representative: <LinkTableCellComponent onLinkClick={() => handleOnCustomerNameClick(contract)} name={contract.representativeName}/>,
                        status: <ContractStatus
                            key={8}
                            status={contract.status}
                            role={auth.role}
                            statusMessage={status?.message}
                        />,
                        delivery: <TableCell>
                            {deliveryActionButton(auth.role, contract.status)}
                        </TableCell>,
                        actions: <div>
                            {
                                userRole === roles.GK && currentStatus === CONTRACT_STATUS.CUSTOMER_SIGNED &&
                                <MenuItem
                                    onClick={() => {
                                        setSelectedContract(contract);
                                        setShowSignContract(true);
                                    }}
                                >
                                    Sign and Approve
                                </MenuItem>
                            }
                            {
                                userRole === roles.GK && currentStatus === CONTRACT_STATUS.DELIVERED &&
                                <MenuItem
                                    onClick={() => updateContractStatus(contract, CONTRACT_STATUS.GK_PAID, paymentIssuedEvent(contract))}
                                >
                                    Payment Issued
                                </MenuItem>
                            }
                            {
                                userRole === roles.SMS && currentStatus === CONTRACT_STATUS.AGREEMENT_SIGNED &&
                                <MenuItem onClick={() => showDeliveryDialog(contract)}>
                                    Send Delivery Slip
                                </MenuItem>
                            }
                            {/*{*/}
                            {/*    userRole === roles.SMS  && currentStatus === contractStatuses.INVOICE_SIGNED &&*/}
                            {/*    <MenuItem onClick={()=> {}}>Confirm Delivery</MenuItem>*/}
                            {/*}*/}
                            {
                                // In INVOICE_SIGNED state the customer signed the invoice and returned it with the courier
                                // The next action is then to upload that singed delivery slip
                                // this action will update the state and notify respective users that devices were delivered
                                // TODO add process for the user to upload the delivery slip.
                                // TODO this option should bring up a dialog to upload delivery slip.
                                userRole === roles.SMS && currentStatus === CONTRACT_STATUS.DELIVERY_SLIP_SIGNED &&
                                <MenuItem
                                    onClick={() => updateContractStatus(contract, CONTRACT_STATUS.DELIVERED, devicesDeliveredEvent(contract))}
                                >Confirm Delivery</MenuItem>
                            }
                            {
                                userRole === roles.SMS && (currentStatus === CONTRACT_STATUS.DELIVERED || currentStatus === CONTRACT_STATUS.GK_PAID) &&
                                <MenuItem
                                    onClick={() => updateContractStatus(contract, CONTRACT_STATUS.PAYMENT_CONFIRMED, paymentConfirmedEvent(contract))}
                                >
                                    Confirm Payment
                                </MenuItem>
                            }

                            {
                                auth?.role === roles.GK && contract.commitmentLetter?.status === COMMITMENT_LETTER_STATUS.CUSTOMER_SIGNED &&
                                currentStatus === CONTRACT_STATUS.GK_SIGNED &&
                                <MenuItem onClick={() => {
                                    handleSignCommitmentClick(contract);
                                }}
                                >
                                    Sign Commitment Letter
                                </MenuItem>
                            }

                            {
                                auth?.role === roles.GK && promissoryNote?.status === PROMISSORY_NOTE_STATUS.CUSTOMER_SIGNED &&
                                currentStatus === CONTRACT_STATUS.GK_SIGNED &&
                                <MenuItem onClick={() => {
                                    handlePromissoryNoteClick(contract);
                                }}
                                >
                                    Sign Promissory Note
                                </MenuItem>
                            }

                            {
                                userRole === roles.GK && contract.commitmentLetter?.documentId !== null && commitmentLetter?.status === CONTRACT_STATUS.GK_SIGNED &&
                                <MenuItem
                                    onClick={() => {
                                        handleViewContract(contract.commitmentLetter?.documentId);
                                        handleOnDialogClose();
                                    }}
                                >
                                    View Commitment Letter
                                </MenuItem>
                            }

                            {
                                userRole === roles.GK && contract.promissoryNote?.documentId !== null && promissoryNote?.status === CONTRACT_STATUS.GK_SIGNED &&
                                <MenuItem
                                    onClick={() => {
                                        handleViewContract(contract.promissoryNote?.documentId);
                                        handleOnDialogClose();
                                    }}
                                >
                                    View Promissory Note
                                </MenuItem>
                            }

                            <MenuItem
                                onClick={() => {
                                    setSelectedContract(contract);
                                    setContractInfoPanel(true);
                                }}
                            >
                                View Contract Details
                            </MenuItem>
                        </div>

                    }
                };
            });
        return [];
    };

    const getSelectedContracts = contractIds => contracts.filter(contract => contractIds.includes(contract.id));
    // Add table cell components
    const contractsWithTableFields = addTableFields(contracts, selectedContracts);

    // Apply search filter
    let filteredContracts = [...contractsWithTableFields];
    if (query) filteredContracts = filterObjectsBy(filteredContracts, ['contractNumber', 'companyName', 'status'], query);

    const sortedContracts = sortItemByField(filteredContracts, 'name');

    const start = paginationPage * paginationRowsPerPage;
    const end = (paginationPage + 1) * paginationRowsPerPage;
    const paginatedContracts = sortedContracts.slice(start, end);

    // Order the table data.
    const orderedCustomerData = groupAndSortItemsByFieldName(paginatedContracts, 'companyName');

    // Pagination functions and variables
    const paginationCount = filteredContracts.length;

    return (
        <PageWrapper>

            <PageHeadingWrapper>
                Contracts
            </PageHeadingWrapper>

            <div style={{margin: '8px 40px'}}>
                <SearchFieldComponent
                    onSearchChange={handleOnSearchChange}
                    placeholder="Filter customer by Company, Status, Contract ID"
                />
            </div>

            {/**
             *  Contracts Table
             **/}
            <TableWrapper>

                <CompanyContractExpansionPanel
                    contractGroups={orderedCustomerData}
                    selectedContracts={selectedContracts}
                    expandedItems={expandedGroups}
                    onExpanded={onExpanded}
                    onCheckBoxSelected={handleOnCheckboxSelected}
                    onSelectAll={handleOnCheckboxGroupClick}
                />

            </TableWrapper>

            {/**
             * Pagination Section
             **/}
            <Motion
                defaultStyle={{y: 200}}
                style={{y: spring(paginationCount >= 1 ? 0 : 200)}}
            >
                {
                    style => (
                        <PaginationWrapper
                            style={{transform: `translateY(${style.y}px)`}}
                        >
                            <Pagination
                                count={paginationCount}
                                page={paginationPage}
                                rowsPerPage={paginationRowsPerPage}
                                onChangePage={handleOnPageChange}
                                onRowsPerPageChange={handleOnRowsPerPageChange}
                            />

                            {
                                showSignAllBtn(selectedContracts.length, auth.role) &&

                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                }}
                                >
                                    <Label> {selectedContracts.length} Selected</Label>
                                    <ActionButton2 onClick={handleOnSignAllBtnClick}>Sign All</ActionButton2>
                                </div>
                            }
                        </PaginationWrapper>
                    )}
            </Motion>

            <ContractSignContainer
                showPanel={showSignContract}
                contracts={
                    (selectedContract) ? [selectedContract] : getSelectedContracts(selectedContracts)
                }
                onPanelClose={() => {
                    setSelectedContract(undefined);
                    setShowSignContract(false);
                }}
            />

            <ContractInfoSidePanel
                contract={selectedContract || {}}
                showPanel={contractInfoPanel}
                onPanelClose={() => {
                    setContractInfoPanel(false);
                    setSelectedContract({});
                }}
                onSignContractClick={handleSignContractClick}
                onViewContractClick={handleOnViewContractClick}
                onReadyForDeliveryClick={showDeliveryDialog}
            />

            <DocumentSignContainer
                showPanel={showDocumentPad}
                onPanelClose={() => enableDocumentPad(false)}
                documentKey={documentKey}
                documentParams={documentParams}
                onDocumentSign={documentId => {
                    documentKey === 'commitment_letter' ? handleGkCommitmentSignature(documentId, selectedContract) : handleGkPromissorySignature(documentId, selectedContract);
                }}
                signatureKey="witness_signature"
            />
            {
                loading ? <LoadingComponent><h1 className="text">{process}</h1></LoadingComponent> : (
                    <ContractDeliveryDialog
                        id={selectedContract && selectedContract.contractNumber}
                        companyName={selectedContract && selectedContract.companyName}
                        onSubmitClick={invoiceNumber => handleOnDialogSubmit(selectedContract, invoiceDocument, invoiceNumber)}
                        setInvoiceDocument={setInvoiceDocument}
                        showDialog={contractDeliveryDialog}
                        onCloseClick={handleOnDialogClose}
                        onDialogClose={handleOnDialogClose}
                    />
                )}

        </PageWrapper>
    );
}

FulfillmentContracts.propTypes = {};
FulfillmentContracts.defaultProps = {};

const mapStateToProps = state => {
    let {contracts} = state;
    const {representatives} = state;

    if (contracts.length && representatives.length) {
        contracts = contracts.map(item => {
            const contractRepresentative = representatives.find(rep => rep.id === item.representativeId);

            return {
                ...item,
                representative: contractRepresentative
            };
        });
    }

    const isFetchingContracts = state.loading[CONTRACTS];

    return {
        auth: state.auth,
        user: state.user,
        contracts: contracts || [],
        apiCallsInProgressCount: state.apiCallsInProgressCount,
        isFetchingContracts,
    };
};

const mapDispatcherToProps = {
    getAllContracts,
    updateContract,
    fetchRepresentatives,
    addNotification,
    agreementSignedEvent,
    updateContractSchedule,
};

export default connect(mapStateToProps, mapDispatcherToProps)(FulfillmentContracts);
